// This page is opened via an email auth link
// - Validates the link client-side
// - Renders <h1> error if the link is invalid

import Layout from '../components/Layout';
import EmailLinkSignInCard from '../components/EmailLinkSignInCard';
import { isEmailLink } from '../utils/firebase';

export default function PageEmailLinkSignIn() {
  const valid = isEmailLink();

  if (!valid) {
    return (
      <Layout screenSized className='page-email-link-signin'>
        <h1>Error: the link is not valid</h1>
      </Layout>
    );
  }

  return (
    <Layout screenSized className='page-email-link-signin'>
      <EmailLinkSignInCard />
    </Layout>
  );
}
